// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"d4e2de20","541":"ddc4f247","688":"c1e1f91d","749":"a7676d12","892":"7d495f2e","927":"d4e2de20","985":"8f266023"}[chunkId] + ".chunk.css";
};